module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/wis/wis-pricing/wis-pricing.component.css
// module id = ./src/app/wis/wis-pricing/wis-pricing.component.css
// module chunks = main